<template lang="html">

    <section class="wrapper wrapper-view -home-alumno">

        <section class="superior container row-between ais">

            <div class="listados-home" :full="!isEstudiante">
                <nav class="selector row-start">
                    <a :active="selector == 'ofertas'" @click="selector = 'ofertas'">Listado de ofertas</a>
                    <a v-if="candidaturas.length != 0" :active="selector == 'candidaturas'" @click="selector = 'candidaturas'">Candidaturas</a>
                </nav>
                <candidaturas v-if="selector == 'candidaturas'"></candidaturas>
                <ofertas v-if="selector == 'ofertas'"></ofertas>
            </div>

            <accesos v-if="isEstudiante"></accesos>

        </section>

        <eventos></eventos>
        <encuestas></encuestas>

        <email-ofertas></email-ofertas>
        <adjuntar-cv></adjuntar-cv>

        <popup-direccion></popup-direccion>

    </section>

</template>

<script lang="js">

    import accesos from '@/components/view-parts/home/accesos';
    import candidaturas from '@/components/view-parts/home/candidaturas';
    import encuestas from '@/components/view-parts/home/encuestas';
    import eventos from '@/components/view-parts/home/eventos';
    import ofertas from '@/components/view-parts/home/ofertas';

    import emailofertas from '@/components/parts/popup-email-ofertas';
    import adjuntarcv from '@/components/parts/popup-adjuntar-cv';
    import adjuntardireccion from '@/components/parts/popup-direccion';

    import {mapGetters} from 'vuex';

    export default {
        name: 'home-alumno',
        data(){
            return{
                selector : 'ofertas'
            }
        },
        components: {
            'accesos' : accesos,
            'candidaturas' : candidaturas,
            'encuestas' : encuestas,
            'ofertas' : ofertas,
            'eventos' : eventos,
            'email-ofertas' : emailofertas,
            'adjuntar-cv' : adjuntarcv,
            'popup-direccion' : adjuntardireccion
        },
        computed : {
            ...mapGetters({
                isEstudiante : 'isEstudiante',
                candidaturas : 'getCandidaturas'
            })
        }
    }
</script>

<style scoped lang="scss">

    .wrapper-view{
        padding: 20px 0;
    }

</style>


// WEBPACK FOOTER //
// src/components/view-parts/home/home-alumno.vue